<script lang="ts">
import { defineComponent } from 'vue';
import type { CreatePool } from '@/types/pools';
import { validateNumber } from '@/components/pools/helpers';
import { mapActions, mapWritableState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';
import { fetchPoolTypes } from '@/api/admin-be';
import CustomSelect from '@/components/custom-select.vue';

export default defineComponent({
  name: 'pools-add',
  components: { CustomSelect },
  computed: {
    ...mapWritableState(usePoolsStore, ['currentPoolId']),
  },
  data() {
    return {
      newPool: {} as CreatePool,
      showAddPool: false,
      poolTypes: null,
    };
  },
  methods: {
    validateNumber,
    ...mapActions(usePoolsStore, ['fetchPools', 'createPool']),
    async createNewPool() {
      return this.createPool(this.newPool).then((data) =>
        this.fetchPools().then(() => (this.currentPoolId = data?.id))
      );
    },
  },
  mounted() {
    fetchPoolTypes({ offset: 0, size: 1000 }).then((result) => (this.poolTypes = result.poolTypes));
  },
});
</script>

<template>
  <tr>
    <td><i class="pi pi-file-plus" /></td>
    <td class="!px-0 !py-0" colspan="3">
      <input
        type="text"
        class="required"
        name="poolName"
        v-model="newPool.name"
        placeholder="Название"
      />
    </td>
    <td>      <DatePicker
      v-model="newPool.startBetAt"
      show-icon
      show-time
      :min-date="new Date()"
      fluid
      icon-display="input"
      placeholder="Начало"
      date-format="dd.mm.yy"
    />
    </td>
    <td>      <DatePicker
      v-model="newPool.endBetAt"
      show-icon
      show-time
      :min-date="newPool.startBetAt"
      fluid
      icon-display="input"
      placeholder="Конец"
      date-format="dd.mm.yy"
    />
    </td>
    <td class="!px-0 !py-0">
      <custom-select
        v-model="newPool.typeId"
        :options="(poolTypes ?? []).map((p) => ({ value: p.id, label: p.name }))"
        placeholder="Тип пула"
      />
    </td>
    <td colspan="4" />
    <td class="!px-0 !py-0">
      <input
        type="number"
        @focusout="newPool.jackpotAmount = validateNumber(newPool.jackpotAmount) as number"
        v-model="newPool.jackpotAmount"
        placeholder="Джекпот, USD"
        name="poolJackpotAmount"
      />
    </td>
    <td>
      <i class="pi pi-plus-circle text-green-500 pt-1 cursor-pointer" @click="createNewPool" />
    </td>
  </tr>
</template>

<style lang="scss" scoped>
input {
  @apply w-full bg-transparent focus:border-none focus:outline-dotted text-center placeholder:font-thin placeholder:italic py-2;
}

.required {
  @apply placeholder-yellow-500;
}
</style>
